import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class BringozDatetimeRangeComponent implements IController {

  form: any;
  from: any;
  to: any;
  min: any;
  max: any;
  name?: string;
  timeOnly: any;
  isRequired: string;
  isDisabled?: boolean;
  isTimeDisabled?: boolean;
  isRow: string;
  onRangeChange: Function;

  timeConfig: any;
  minDate: any;
  maxDate: any;

  constructor(private moment) {
  }

  $onInit() {
    if (!this.from && !this.to) {
      this.from = this.moment().startOf('day').valueOf()
      this.to = this.moment().endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
    }
    if (this.min) {
      this.minDate = new Date(this.min)
    }
    if (this.max) {
      this.maxDate = new Date(this.max)
    }

    this.setConfig(this.from, this.to);
  }

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange()) {
      this.setConfig(this.from, this.to);
    }
    if (changes.to && !changes.to.isFirstChange()) {
      this.setConfig(this.from, this.to);
    }
  }

  onFromDateChange(from) {
    let fromDateMomentRef = this.moment(from);
    let day = fromDateMomentRef.date(),
      month = fromDateMomentRef.month(),
      year = fromDateMomentRef.year();

    this.timeConfig.from.value = this.moment(this.timeConfig.from.value).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    if (!this.moment(this.timeConfig.from.date).isSame(this.moment(this.timeConfig.to.date), 'date')) {
      this.timeConfig.to.date = this.moment(from).toDate();
      this.timeConfig.to.value = this.moment(from).endOf('day').set({
        'minute': 45,
        'second': 0,
        'millisecond': 0
      }).valueOf();
    }

    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  onFromTimeChange(time) {
    this.timeConfig.from.value = time;
    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  onToTimeChange(time) {
    this.timeConfig.to.value = time;
    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  private setConfig(from, to) {
    this.timeConfig = {
      from: {
        date: this.moment(from).toDate(),
        value: this.moment(from).valueOf(),
      },
      to: {
        date: this.moment(to).toDate(),
        value: this.moment(to).valueOf(),
      }
    };

    if (this.form && _.get(this.form, 'dateRange')) {
      let isValid = this.timeConfig.from.value < this.timeConfig.to.value ||
        this.timeConfig.to.value > this.timeConfig.from.value;

      this.form.dateRange.$setValidity('isValid', isValid);
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozDatetimeRange', {
    require: {
      form: '?^form'
    },
    bindings: {
      from: '<',
      to: '<',
      min: '<?',
      max: '<?',
      name: '@?',
      timeOnly: '<',
      isRequired: '@?',
      isDisabled: '<?',
      isTimeDisabled: '<?',
      isRow: '@?',
      onRangeChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-datetime-range/bringoz-datetime-range.html',
    controller: BringozDatetimeRangeComponent
  });
